var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuidePopupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 604.828 604.828",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.738,139.34v381.816h446.707V0H172.297L37.738,139.34z M225.23,45.422h215.156v430.312H81.793V188.859H225.23V45.422 L225.23,45.422z M184.59,145.828H85.68l98.915-98.915v98.915H184.59z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.824,
    y: 107.578,
    width: 136.266,
    height: 46.617
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.41,
    y: 232.488,
    width: 132.68,
    height: 51.398
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.996,
    y: 357.398,
    width: 127.898,
    height: 46.617
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "528.84,566.578 112.871,566.578 112.871,604.828 567.09,604.828 567.09,78.891 528.84,78.891  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.652,
    y: 231.891,
    width: 124.312,
    height: 172.125
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidePopupIcon);
export default __webpack_public_path__ + "static/media/guidePopupIcon.fcfd8a7dced84749b91ffdbdc2d3a8ba.svg";
export { ForwardRef as ReactComponent };